import { render } from "./UnsubscribeModal.vue?vue&type=template&id=0f601cd9"
import script from "./UnsubscribeModal.vue?vue&type=script&lang=js"
export * from "./UnsubscribeModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/smartphone/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__